import type { Chat400Details } from './chat400Details';
import type { Chat400ErrorsItem } from './chat400ErrorsItem';

/**
 * 통합 에러 응답 형식 - 모든 서비스에서 사용
 */
export type Chat400 = {
  /**
   * 상세 에러 정보 (선택적)
   * @nullable
   */
  details?: Chat400Details;
  /** 표준화된 에러 코드 */
  errorCode: string;
  /** 필드별 검증 에러 목록 (선택적) */
  errors?: Chat400ErrorsItem[];
  /** 사용자에게 표시할 에러 메시지 */
  message: string;
  /** 요청 경로 (선택적) */
  path?: string;
  /** 요청 성공 여부 (항상 false) */
  success: boolean;
  /** 에러 발생 시간 */
  timestamp: string;
};
